import { BaseApiService } from '../../base-api-service';
import { HTTPResponse, PGWheelInfo } from '../../../models';
import { ApiVersions } from '../../../enums';
import { env } from '../../../environment';

export interface BoostedJackpotSpinPayload {
  wheelId: number;
  gameId: number;
}

class BoostedJackpotController extends BaseApiService {

  public async spin(payload: BoostedJackpotSpinPayload): Promise<HTTPResponse> {
    const url = `${this.url}/pgwheel/api/${ApiVersions.V1}/Wheels/spin`;
    return await this.http.post(url, payload, { skipInterceptor: true });
  }

  public async getWheelInfo(wheelId: number): Promise<HTTPResponse<PGWheelInfo>> {
    const url = `${this.url}/pgwheel/api/${ApiVersions.V1}/Wheels/${wheelId}/info`;
    return await this.http.get(url, { skipInterceptor: true });
  }

}

export const boostedJackpotController = new BoostedJackpotController({ url: env.origin });